import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontRoboto, fontRobotoCondensed, theme, transientOptions } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";
import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div``;

export const Divider = styled.div`
  margin-block: 16px 16px;
  border-block-start: 1px solid #bbbbbb;
`;

export const ExtraMetadataContainer = styled.div`
  display: grid;
  gap: 16px;

  ${theme.breakpoints.between("tablet", "desktop")} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ExtraMetadataItem = styled.div`
  display: flex;
  gap: 4px;
  justify-content: space-between;
  align-items: center;

  font-size: 14px;
  line-height: 140%;
`;

export const MetadataTitle = styled.div`
  color: #000000;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: 14.06px;
  text-align: start;
  text-transform: uppercase;
`;

export const MetadataDescription = styled.div`
  color: #666666;
  font-weight: 400;
  font-size: 14px;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 20.8px;
  text-align: start;

  a {
    color: #666666;
    text-decoration: underline;
    text-decoration-skip-ink: none;
  }
`;

export const StyledBaseLink = styled(BaseLink, { ...transientOptions })`
  display: flex;
  align-items: center;

  color: #4585ff;
  font-weight: 400;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  line-height: 20.8px;
  text-align: start;
  text-decoration: underline;
`;

export const ImageIcon = styled(BaseImage)`
  inline-size: 48px;
  block-size: 48px;

  border: 1px solid #bbbbbb;
  border-radius: 50%;

  object-fit: cover;
  object-position: 50%;
`;

export const MetadataRow = styled.div`
  display: grid;
  gap: 4px;
  align-items: center;
`;

export const StyledEntityLink = styled(EntityLink)``;

export const AdditionalMetadataContainer = styled.div`
  display: flex;
  row-gap: 16px;
`;

export const AdditionalMetadataItem = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  justify-content: space-between;

  font-size: 14px;
  line-height: 140%;
`;

export const AdditionalMetadataPropertyItemContainer = styled.div`
  display: grid;
  gap: 16px;

  ${theme.breakpoints.between("tablet", "desktop")} {
    grid-template-columns: 1fr 1fr;

    & > :first-child {
      grid-column: 1 / -1;
    }
  }
`;

export const AdditionalMetadataPropertyItem = styled.div``;

export const AdditionalMetadataPropertyType = styled.div`
  color: #c59f66;
  font-weight: 400;
  font-size: 10px;
  font-family: ${fontRoboto};
  font-style: normal;

  &:first-letter {
    text-transform: uppercase;
  }
`;

export const LogoIcon = styled(BaseImage)`
  inline-size: 110.92px;

  object-fit: contain;
`;
